var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconContracts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5ebdd4;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.745,13.5H27V10.366A1.368,1.368,0,0,0,25.634,9H25V0H5V1H3.5V2H2V5.5H1.366A1.368,1.368,0,0,0,0,6.866V28.709H0A1.277,1.277,0,0,0,1.283,30h22.38a1.268,1.268,0,0,0,1.225-.906L30,15.074v-.089A1.339,1.339,0,0,0,28.745,13.5ZM25.634,10a.366.366,0,0,1,.366.366V13.5H25V10ZM24,1V13.5H6.366a1.28,1.28,0,0,0-.337.049c-.009,0-.019,0-.029,0V1ZM5,2V14.792l-.031.086L4.5,16.163V2ZM3,3h.5V18.9L3,20.275V3ZM1,6.866A.366.366,0,0,1,1.366,6.5H2V22.971L1,25.7ZM23.934,28.792a.281.281,0,0,1-.272.208H1.283a.276.276,0,0,1-.224-.111.271.271,0,0,1-.062-.2l1-2.75H2l1.5-4.112h0L5,17.71H5l.966-2.65L6,14.969H6l.08-.22.013-.041a.283.283,0,0,1,.273-.208h22.38c.19,0,.239.273.251.409Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.5,16h12a.5.5,0,0,0,0-1h-12a.5.5,0,0,0,0,1Z",
    transform: "translate(-8.5 -7.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.5,9h5a.5.5,0,1,0,0-1h-5a.5.5,0,1,0,0,1Z",
    transform: "translate(-8.5 -4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.5,23h12a.5.5,0,1,0,0-1h-12a.5.5,0,1,0,0,1Z",
    transform: "translate(-8.5 -11)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContracts);
export default __webpack_public_path__ + "static/media/iconContracts.f81707b81c00e6c4e66bf04dd17d0215.svg";
export { ForwardRef as ReactComponent };